import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'
import { venuePublicPageSettingsDtoSchema, type VenuePublicPageSettingsDto } from '@lib/dto/venue-public-page.dto'
import type { UpdateVenuePublicPageInput } from '@lib/input/venue-public-page.input'
import type { IVenuePageService } from '@/types/VenuePageService.types'

/** A venue's page on the public site, from Venue setup (docs/public-site.spec.md). */
class VenuePageService implements IVenuePageService {
  async settings(venueId: string): Promise<VenuePublicPageSettingsDto> {
    try {
      return await api.get(`/venues/${venueId}/public-page`, venuePublicPageSettingsDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to load the venue’s public page', { venueId }, error)
      throw error
    }
  }

  async update(venueId: string, input: UpdateVenuePublicPageInput): Promise<VenuePublicPageSettingsDto> {
    try {
      return await api.put(`/venues/${venueId}/public-page`, input, venuePublicPageSettingsDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to change the venue’s public page', { venueId }, error)
      throw error
    }
  }
}

export const venuePageService = new VenuePageService()
